import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import ProjectBlurb from '../project-blurb';
import Reveal from '../../reveal';
import RevealEdges from '../../animations/reveal-edges';
import RevealSlideDown from '../../animations/reveal-slide-down';
import { css } from 'emotion';

const CreativeSnapshotContent = props => {
  const { wrapperPadding, isInView, image, blurb, animation } = props;
  return (
    <div
      className={css`
        padding: ${wrapperPadding};
        position: relative;
      `}
      style={animation}
    >
      <RevealEdges isInView={isInView} />
      <Img
        sizes={image.localFile.childImageSharp.sizes}
        backgroundColor={true}
        alt={blurb}
      />
      <ProjectBlurb blurb={blurb} />
    </div>
  );
};

const ProjectCreativeSnapshot = props => {
  return (
    <Reveal>
      <RevealSlideDown isInView={props.isInView}>
        <CreativeSnapshotContent {...props} />
      </RevealSlideDown>
    </Reveal>
  );
};

ProjectCreativeSnapshot.propTypes = {
  wrapperPadding: PropTypes.string,
  isInView: PropTypes.bool,
  image: PropTypes.object,
  blurb: PropTypes.string,
  animation: PropTypes.object,
};

export default ProjectCreativeSnapshot;



// WEBPACK FOOTER //
// ./src/components/project/project-creative-snapshot/index.js